import React, { useState } from 'react';
import { format } from 'date-fns';

import ProductModal from '../ProductModal/ProductModal';
import Header from '../Header/Header';
import CalendarFilterIcon from '../../icons/CalendarFilterIcon';
import ContentApp from '../../ContentApp';
import Calendar from '../Calendar/Calendar';
import InputFormBorder from './InputFormBorder';
import './input-form-border.css';

const DatePickerBorder = ({ placeholder, value, onChange, error }) => {
  const [calendarVisible, setCalendarVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  const handleDateChange = (date) => {
    setSelectedDate(format(date, 'dd/MM/yyyy'));
    onChange(format(date, 'yyyy-MM-dd'));
    setCalendarVisible(false);
  };

  return (
    <>
      <div onClick={() => setCalendarVisible(true)}>
        <InputFormBorder
          value={selectedDate}
          onChange={handleDateChange}
          placeholder={placeholder}
          error={error}
          iconImg={<CalendarFilterIcon size={24} />}
          disableFocus={true}
        />
      </div>

      <ProductModal
        open={calendarVisible}
        fullScreen
        animationClass='fade-up-horizontal'
        hasBackground
        showCloseButton={false}
      >
        <Header onClick={() => setCalendarVisible(false)} showBack />
        <ContentApp>
          <div className='my-calendar-container datepicker-border-calendar'>
            <Calendar
              onSelectDate={handleDateChange}
              selectedDate={value}
              minDate={new Date()}
              className='calendar-event'
            />
          </div>
        </ContentApp>
      </ProductModal>
    </>
  );
};

export default DatePickerBorder;
